import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import type { FirestoreSettingsCatalogs } from './schema'
import { schema } from './schema'
import { getDocWithError } from '../../firestore-mobx/fetch'

export * from './schema'

const converter: FirestoreDataConverter<FirestoreSettingsCatalogs> = {
  toFirestore: (user: FirestoreSettingsCatalogs) => user,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    return schema.parse(snapshot.data())
  },
}

export const getDocRef = (firestore: Firestore) => {
  return doc(
    collection(firestore, 'settings').withConverter(converter),
    'catalogs'
  )
}

export const fetchSettingsProtectedCatalogIds = async (
  repository: FirebaseRepository
) => {
  const docRef = getDocRef(repository.firestore)

  const doc = await getDocWithError(
    docRef,
    'FetchSettingsProtectedCatalogIdsError'
  )

  if (doc.exists()) {
    const data = doc.data()
    return data.protected
  } else {
    return []
  }
}
